// removed by extract-text-webpack-plugin
module.exports = {"container":"_1mX5w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedNow.less
// module id = ./src/components/Home/FeaturedNow.less
// module chunks = 2